export const editorControlBreakpoints = [
    // Editor breakpoints, from smallest to largest (order must be smallest to largest)
    [0, 330, "xs"],
    [330, 450, "sm"],
    [450, 570, "md"],
    [570, 680, "lg"],
    [680, null, "xl"],
] as const;

/**
 * Defines the breakpoint names in which to collapse/expand controls. "inf" should really only be used
 * for testing purposes
 */
export type EditorControlBreakpointNames = (typeof editorControlBreakpoints)[number][2] | "inf";
